<template>
    <div>
        <vs-dialog blur v-model="qosic_dialog">
        <template #header>
          <h4 class="not-margin">Confirmation Depot</h4>
        </template>
        <div class="con-form">
          <div class="center examplex">
            <vs-table striped>
              <template #tbody>
                <vs-tr>
                  <vs-th> MOYEN DE PAIEMENT </vs-th>
                  <vs-th> <vs-select placeholder="Select" v-model="type">
                      <vs-option label="MTN BENIN" value="MTN BENIN">
                        <vs-avatar size="20">
                          <img src="/img/mtn.svg" alt="">
                        </vs-avatar>
                        MTN-BENIN
                      </vs-option>
                      <vs-option label="MOOV BENIN" value="MOOV BENIN">
                        <vs-avatar size="20">
                          <img src="/img/moov.png" alt="">
                        </vs-avatar>
                        MOOV-BENIN
                      </vs-option>
                    </vs-select> 
                </vs-th>
                </vs-tr>
                <vs-tr>
                  <vs-th> MONTANT </vs-th>
                  <vs-th style="font-size: 1.5em">{{montant}} </vs-th>
                </vs-tr>

                <vs-tr>
                  <vs-th> Frais Réseau </vs-th>
                  <vs-th class="warning--text">{{Number(momo_fee*montant).toFixed(2)}} </vs-th>
                </vs-tr>
                 <vs-tr>
                  <vs-th> Total crédité sur compte </vs-th>
                  <vs-th style="font-size: 1.3em">{{Number(montant) - momo_fee*montant}} </vs-th>
                </vs-tr>
                <vs-tr>
                  <vs-th> NUMERO sans indicatif </vs-th>
                  <vs-th><vs-input type="number" v-model="phone_number" placeholder="Numero sans indicatif" style="font-size: 1.7em" /> </vs-th>
                </vs-tr>
                
              </template>
            </vs-table>
          </div>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-button block @click="intouch">
              Deposer
            </vs-button>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>

<script>
import firebase from '../../fb'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
    export default {
        props: {
            amount:String
        },
        data() {
            return {
                qosic_dialog:false,
                momo_fee:0.02,
                otp:'',
                phone_number:'',
                type:'',
                bf_dialog:false
            }
        },
        computed: {
            montant() {
                return this.amount
            },
        },
mounted () {
           this.$root.$on('qosic_benin', () => {
               this.qosic_dialog= true
            }); 
        },

methods: {
intouch(){

    if (this.phone_number.length !== 8) {
        alert('veuillez saisir un numeero a 8 chiffres')
        return
    }

    if (this.type.length < 6) {
        alert('veuillez selectionner un moyen de paiement')
        return
    }

    if (this.montant < 500) {
        alert('montant minimum de depot est de 500 fr')
        return
    }
    
    const loading = this.$vs.loading()
      let user = firebase.auth().currentUser
      let moyen = this.type
      let user_id = user.uid

      let data ={
          moyen,
          amount: this.montant,
          user_id,
          phone_number : this.phone_number,
          type: 'deposit'
      }
      console.log(data);
    
  let base_url = this.base_url
              if (location.hostname === "localhost") {
                  base_url = 'http://localhost:4000'
                }
  let url = `${base_url}/qosic/deposit`
  console.log(url);
      console.log(data);
          axios.post(url,data).then(res=>{
            loading.close()
            console.log(res.data);
            

            if (res.data == 'success') {
                swal('Dépot en cours', 'Veuillez confirmer sur votre telephone', "success", {button: "ok"});
                }
                else{
                    swal('Error', 'Erreur veuillez verifier vos données et reessayer', "error", {button: "ok"});
                }
            
            this.qosic_dialog = false
            
      }).catch(e=>{
        console.log(e);
      })

    },
        },
        
    }
</script>

<style lang="scss" scoped>

</style>